type AttachRealtimeCallParams = {
  attachEndpoint: string;
  callId: string;
  clientSecret: string;
  seedContext?: unknown;
  agent?: string;
  agentType?: "openai_audio" | "deepgram_tts" | "deepgram_agent";
};

export async function attachRealtimeCall({
  attachEndpoint,
  callId,
  clientSecret,
  seedContext,
  agent,
  agentType,
}: AttachRealtimeCallParams) {
  return fetch(attachEndpoint, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      callId,
      client_secret: clientSecret,
      ...(seedContext ? { seed_context: seedContext } : {}),
      ...(agent ? { agent } : {}),
      ...(agentType ? { agent_type: agentType } : {}),
    }),
  });
}
